<style>
    body {
        text-align: center;
    }

    h1 {
        font-size: 50px;
    }

    body {
        font: 20px Helvetica, sans-serif;
        color: #333;
    }

    article {
        display: block;
        text-align: left;
        width: 650px;
        margin: 0 auto;
    }

    a {
        color: #dc8100;
        text-decoration: none;
    }

    a:hover {
        color: #333;
        text-decoration: none;
    }
</style>
<div class="page-wrap height-100 mat-bg-primary">
    <article>
        <h1>{{ 'Maintenance.BackSoon' | translate }}</h1>
        <div>
            <p>{{ 'Maintenance.SorryIntro' | translate }}
                <a href="https://tachosafe.freshdesk.com">{{ 'Maintenance.ContactUs' | translate }}</a>{{
                'Maintenance.SorryOutro' | translate }}
            </p>
            <p>{{ 'Maintenance.TheTeam' | translate }}</p>
        </div>
    </article>
</div>